import { render } from "./UserAccount.vue?vue&type=template&id=3ad1dc24&scoped=true"
import script from "./UserAccount.vue?vue&type=script&lang=js"
export * from "./UserAccount.vue?vue&type=script&lang=js"

import "./UserAccount.vue?vue&type=style&index=0&id=3ad1dc24&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-3ad1dc24"

export default script